<template>
    <div>
        <a
            class="btn btn-md is-ghost px-2xl is-danger"
            @click="$modal.show('deactivate-company')"
        >
            Inaktivera
        </a>
        <adaptive-form-modal
            name="deactivate-company"
            primary-button-text="Inaktivera entreprenören"
            primary-button-class="is-danger"
            title="Inaktivera entreprenör"
            :redirect-to="route('admin.companies.index')"
            method="patch"
            :action="route('api.companies.deactivate', company)"
        >
            Vill du verkligen inaktivera {{ company.name }}?

            <p class="mt-sm">
                Detta leder till att samtliga användare i entrepenörsbolaget också
                kommer att inaktiveras.
            </p>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            company: {
                type: Object,
                required: true,
            },
        },
    };
</script>
